import React from 'react';

function WabaAccessTab({
  allMessages,
  assignedMessages,
  selectedMessageIds,
  setSelectedMessageIds,
  handleWabaAssign,
  handleWabaRemove
}) {
  return (
    <div className="row">
      <div className="col-md-5">
        <h6>All WABA Messages</h6>
        <select
          className="form-select"
          multiple
          size="10"
          value={selectedMessageIds}
          onChange={(e) =>
            setSelectedMessageIds(Array.from(e.target.selectedOptions).map(opt => opt.value))
          }
        >
          {allMessages.map(msg => (
            <option key={msg.id} value={msg.id}>{msg.description}</option>
          ))}
        </select>
      </div>

      <div className="col-md-2 d-flex align-items-center justify-content-center">
        <button className="btn btn-primary" onClick={handleWabaAssign}>&gt;&gt;</button>
      </div>

      <div className="col-md-5">
        <h6>Assigned WABA Messages</h6>
        <ul className="list-group">
          {assignedMessages.map(msg => (
            <li key={msg.id} className="list-group-item">
              {msg.description}
              <button className="btn btn-sm btn-danger float-end" onClick={() => handleWabaRemove(msg.id)}>
                &lt;&lt;
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default WabaAccessTab;
